import { IGenerateGnreBody, IGenerateGnreParams, IGenerateGnreResponse, ICheckGeneratedGnreResponse, IEligibleGnreInvoicesResponse } from "@/@types/tax-integration";
import { GnreProgressResponse } from "@/@types/gnre-job-progress";
import { apiSlice } from "./http";
import { Tags } from "@/enum/tags";

export const taxIntegrationService = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    generateGnre: builder.mutation<
      IGenerateGnreResponse,
      { params: IGenerateGnreParams; body: IGenerateGnreBody }
    >({
      query: ({ params, body }) => {
        const urlParams = new URLSearchParams(params as unknown as Record<string, string>);
        return {
          url: `/tax-integration/generate-gnre?${urlParams.toString()}`,
          method: "POST",
          body,
        };
      },
      invalidatesTags: [Tags.TAX_INTEGRATION],
    }),
    checkGeneratDGnre: builder.mutation<
      ICheckGeneratedGnreResponse,
      { params: IGenerateGnreParams }
    >({
      query: ({ params }) => {
        const urlParams = new URLSearchParams(params as unknown as Record<string, string>);
        return {
          url: `/tax-integration/check-generated-gnre?${urlParams.toString()}`,
          method: "GET",
        };
      },
      invalidatesTags: [Tags.TAX_INTEGRATION],
    }),
    getEligibleGnreInvoices: builder.query<
      IEligibleGnreInvoicesResponse,
      { startDate: string; endDate: string; filterGenerated: boolean }
    >({
      query: ({ startDate, endDate, filterGenerated }) => {
        const urlParams = new URLSearchParams({
          startDate,
          endDate,
          filterGenerated: String(filterGenerated),
        });
        return {
          url: `/tax-integration/eligible-gnre-invoices?${urlParams.toString()}`,
          method: "GET",
        };
      },
      providesTags: [Tags.TAX_INTEGRATION],
    }),
    getGnreProgress: builder.query<GnreProgressResponse, void>({
      query: () => ({
        url: `/tax-integration/gnre-progress`,
        method: "GET",
      }),
    }),
    cancelGnreJob: builder.mutation<{ message: string }, string>({
      query: (jobId) => ({
        url: `/tax-integration/gnre-progress/${jobId}/cancel`,
        method: "POST",
      }),
    }),
  }),

  overrideExisting: true,
});

export const { useGenerateGnreMutation, useCheckGeneratDGnreMutation, useGetEligibleGnreInvoicesQuery, useGetGnreProgressQuery, useCancelGnreJobMutation } = taxIntegrationService;

export const {
  endpoints: {
    generateGnre: { select: selectGenerateGnre },
    checkGeneratDGnre: { select: selectCheckGeneratDGnre },
    getGnreProgress: { select: selectGetGnreProgress },
  },
} = taxIntegrationService;
